import React, { useContext, useEffect } from "react";
import { GrigoraPostEditorContext } from "../post-edit/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "../input";

function RightBar({ title, icon }) {
  const { isBlockSettingsVisible, setIsBlockSettingsVisible } = useContext(
    GrigoraPostEditorContext,
  );

  return (
    <>
      <div className="flex items-center gap-2">
        {/* {icon} */}
        <div className="text-ui-text-heading font-medium"> {title} </div>
      </div>
      <Tooltip text={"Close"} placement="left">
        <span
          className="editor-icon-btn"
          onClick={() => setIsBlockSettingsVisible(false)}
        >
          <FontAwesomeIcon className="cursor-pointer" icon={faXmark} />
        </span>
      </Tooltip>
    </>
  );
}

export default RightBar;
